import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { animate, state, style, transition, trigger } from '@angular/animations';
import { ConfirmationDialogComponent } from 'src/app/controls/confirmation-dialog/confirmation-dialog.component';
import { CancelDialogComponent } from 'src/app/controls/cancel-dialog/cancel-dialog.component';

@Component({
  selector: 'app-incoming-booking',
  templateUrl: './incoming-booking.component.html',
  styleUrls: ['./incoming-booking.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class IncomingBookingComponent extends BaseComponent implements OnInit, AfterViewInit {

  // expandedElement: any;
  appointments: any[] = [];
  appointmentsColumns: string[] = ['date', 'action'];
  dsAppointments!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  expandedElement: any;

  addEvents: any[] = [];

  ngOnInit() {
    this.baseTriggerChild.subscribe((event) => {
      this.app.pageTitle = 'Bookings';
      this.addEvents = [
        {
          description: 'Apple',
          dataDirect: 'apple',
          icon: 'https://www.addevent.com/gfx/icon-apple-t5.svg',
          allDay: 'false',
          dateFormat: 'MM/DD/YYYY',
        },
        {
          description: 'Google&nbsp;<em>(online)</em>',
          dataDirect: 'google',
          icon: 'https://www.addevent.com/gfx/icon-google-t5.svg',
          allDay: 'false',
          dateFormat: 'MM/DD/YYYY',
        },
        {
          description: 'Outlook',
          dataDirect: 'outlook',
          icon: 'https://www.addevent.com/gfx/icon-outlook-t5.svg',
          allDay: 'false',
          dateFormat: 'MM/DD/YYYY',
        },
        {
          description: 'Outlook.com<em>(online)</em>',
          dataDirect: 'outlookcom',
          icon: 'https://www.addevent.com/gfx/icon-outlookcom-t5.svg',
          allDay: 'false',
          dateFormat: 'MM/DD/YYYY',
        },
        {
          description: 'Yahoo<em>(online)</em>',
          dataDirect: 'yahoo',
          icon: 'https://www.addevent.com/gfx/icon-yahoo-t5.svg',
          allDay: 'false',
          dateFormat: 'MM/DD/YYYY',
        },
      ];
     
      this.getIncomingAppointments();

    });
  }

  ngAfterViewInit(): void {
    this.start();
  }

  loadExternalScript(scriptUrl: string): any {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    });
  }

  back() {
    history.back();
  }

  locateUs(): void {
    this.app.router.navigate(['customer/locate-us']);
  }

  redirectToCancelAppointment(appointment: any) {
    this.app.storageService.setItem(AppConstants.Appointment, JSON.stringify(appointment));
    this.app.router.navigate(['customer/cancel-appointment']);
  }

  confirmDialog(appointment: any): void {
    const dialogRef = this.app.dialog.open(ConfirmationDialogComponent, {
      data: { action: '0' },
    });
    dialogRef.afterClosed().subscribe((result: { action: string; } | null) => {
      console.log(result);
      if (result != null) {
        if (result.action == '1') {
          this.confirmAppointment(appointment);
        }
      }
    });
  }

  confirmAppointment(appointment: any) {
    const model = {
      appointmentId: appointment.appointmentId,
      customerId: this.app.customer.customerId,
      branchId: appointment.branchId
    };
    this.app.spinner.show();
    this.app.webBookingService.ConfirmAppointmentByAppoitnmentId(model)
      .subscribe(
        (data) => {
          this.showSuccessMessage('We are looking forward to seeing you.  You can click on More Info to check details about your appointment.<br><br>');
          this.getIncomingAppointments();
        },
        (error) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }  

  cancelDialog(appointment: any): void {
    if(appointment.hoursBeforeAppointment <= 48)
    {
      this.showMessageBox('You appointment is within 48 hours please contact us on <a href="tel:+61293022888">+612 9302 2888</a> to reschedule or cancel.<br><br>');
    }
    else{
      const dialogRef = this.app.dialog.open(CancelDialogComponent, {
        data: { action: '0', appointment: appointment },
      });
      dialogRef.afterClosed().subscribe((result: { action: string; } | null) => {
        console.log(result);
        if (result != null) {
          if (result.action == '1') {
            this.cancelAppointment(appointment);
          }
        }
      });
    } 
  }

  cancelAppointment(appointment: any) {
    const model = {
      appointmentId: appointment.appointmentId,
      customerId: this.app.customer.customerId,
      branchId: appointment.branchId
    };
    this.app.spinner.show();
    this.app.webBookingService.CancelAppointmentByAppoitnmentId(model)
      .subscribe(
        (data) => {
          if(appointment.isPaid)
          {
            this.showMessageBox('Your payment is in credit on your patient profile. Please contact us on <a href="tel:+61293022888">+612 9302 2888</a> if you require a refund.<br><br>');
          }          
          this.getIncomingAppointments();
        },
        (error) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getIncomingAppointments() {
    this.app.spinner.show();
    this.app.webBookingService.GetIncomingAppointments()
      .subscribe(
        (data: any) => {
          this.appointments = data == null ? [] : data;
          this.dsAppointments = new MatTableDataSource(this.appointments);
          setTimeout(() => {
            this.dsAppointments.paginator = this.paginator;
            this.dsAppointments.sort = this.sort;
            this.app.spinner.hide();
          }, 500);
          this.loadExternalScript('https://addevent.com/libs/atc/1.6.1/atc.min.js');
        },
        (error: string) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }
  
  showMessageBox(message: string): void {
    const dialogRef = this.app.dialog.open(ConfirmationDialogComponent, {
      data: { 
        action: '0',
        description: message,
        showConfirm: false
      },
    });
    dialogRef.afterClosed().subscribe((result: { action: string; } | null) => {
      console.log(result);
      if (result != null) {
        if (result.action == '1') {
        }
      }
    });
  }

  reschedule(appointment: any) {
    if(appointment.hoursBeforeAppointment <= 48)
    {
      this.showMessageBox('You appointment is within 48 hours please contact us on <a href="tel:+61293022888">+612 9302 2888</a> to reschedule or cancel.<br><br>');
    }
    else{
      this.app.router.navigate(['customer/reschedule'], { queryParams: { aid: appointment.appointmentId } });
    }    
  }
  
  rebook(appointment: any) {   
    const model = {
      appointmentId: appointment.appointmentId
    }; 
    this.app.spinner.show();
    this.app.webBookingService.GetTreatmentsByAppointmentId(model)
      .subscribe(
        (data: any) => {
          this.app.storageService.setItem(AppConstants.BookingSelectedTreatment, JSON.stringify(data));
          this.app.router.navigate([AppConstants.RouteSelectPractitioner]);
        },
        (error: string) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

}

